const cs = {
  'base.noData': 'žádná data',
  'base.itemNoteFound': 'Položka nenalezena',

  'login.label': 'Přihlášení',
  'login.button.label': 'Přihlásit',
  'login.username': 'Uživatelské jméno',
  'login.password': 'Heslo',

  'error.invalidCredentials': 'Špatné jméno nebo heslo',
  'error.unknownError': 'Neznámá chyba',

  'transaction.openedTransactions': 'Rozpracované účtenky',
  'transaction.closedTransactions': 'Uzavřené účtenky',
  'transaction.reservationSystem': 'Rezervační systém',

  'transaction.cancel': 'Stornovat účtenku',
  'transaction.editNote': 'Upravit komentář',

  'transaction.id': 'ID transakce',
  'transaction.createdBy': 'Vytvořil',
  'transaction.createdOn': 'Vytvořeno',
  'transaction.documentNo': 'Číslo dokladu',
  'transaction.total': 'Celkem',
  'transaction.payments': 'Platby',
  'transaction.itemCount': 'Počet položek',
  'transaction.note': 'Poznámka',
  'transaction.closedBy': 'Uzavřel',
  'transaction.closedOn': 'Uzavřeno',
  'transaction.new': 'Vytvořit účtenku',
  'transaction.notOpened': 'Transakce je uzavřena pro změny',
  'transaction.successfullyPosted': 'Účtenka {transactionNo} vytvořena',
  'transaction.successfullyCancelled': 'Účtenka stornována',
  'transaction.seriesNotSet': 'Není nastavena číselná řada',
  'transaction.doYouWantToLeaveUnfinished': 'Skutečně si přejete opustit rozpracovanou účtenku?',
  'transaction.grossAmount': 'Celkem',
  'transaction.netAmount': 'Základ daně',
  'transaction.taxAmount': 'Daň',
  'transaction.taxPercentage': 'Procenta daně',
  'transaction.items': 'Položky',
  'transaction.item.name': 'Položka',
  'transaction.item.quantity': 'Množství',

  'closure.transactionCount': 'Počet dokladů',
  'closure.grossAmount': 'Celkem s DPH',
  'closure.netAmount': 'Celkem bez DPH',
  'closure.taxAmount': 'DPH',
  'closure.paymentType': 'Typ platby',
  'closure.paymentCount': 'Počet plateb',
  'closure.paymentAmount': 'Částka',

  'closure.taxPercentage': 'Sazba',

  'transactionLine.name': 'Název',
  'transactionLine.quantity': 'Množství',
  'transactionLine.unitAmount': 'Jedn.cena',
  'transactionLine.amount': 'Celkem',

  'postedTransaction.closedOn': 'Uzavřeno',

  'reservationSystem.initials': 'Iniciály',

  'template.notOpened': 'Šablona není k dispozici',

  'stats.receipt.count': 'Počet účtenek',
  'stats.updated': 'Aktualizováno',

  'payment.title': 'Platba',
  'payment.card': 'Platební karta',
  'payment.cash': 'Hotovost',

  'receipt.pay': 'Zaplatit',

  'error.invalid_input': 'Neplatný vstup',
  'error.not_opened': 'Neplatný vstup',
  'error.not_related': 'Neplatný vstup',
  'error.pos_not_found': 'Pokladna nenalezena',
  'error.pos_not_set': 'Transakce nemá přiřazenou pokladnu',
  'error.series_not_set': 'Pokladna nemá přiřazenou číselnou řadu',
  'error.transaction_not_balanced': 'Transakce není vyrovnaná',
  'error.transaction_line_inconsistency': 'Chyba položky transakce',
  'error.payments_inconsistency': 'Nekonzistence plateb',
  'error.default': 'Neznámá chyba',

  'pos.receipt.header.itemsCount':
    '{itemsCount, plural, =0 {Žádná položka} one {{itemsCount} položka} few {{itemsCount} položky} other {{itemsCount} položek}}',
  'dataTable.pagination.rowsPerPage': 'Řádků na stránku',
  'dataTable.pagination.summary': '{from}-{to} z {count}',
};

export default cs;
